export const CATEGORY_PROFESSIONAL_KITCHEN = "PROFESSIONAL_KITCHEN";
export const CATEGORY_DELIVERY_TRUCK = "DELIVERY_TRUCK";
export const CATEGORY_STORAGE_SPACE = "STORAGE_SPACE";
export const CATEGORY_PROFESSIONAL_COOKING_EQUIPMENT = "PROFESSIONAL_COOKING_EQUIPMENT";
export const CATEGORY_PREP_EQUIPMENT = "PREP_EQUIPMENT";
export const CATEGORY_REFRIGERATION_EQUIPMENT = "REFRIGERATION_EQUIPMENT";
export const CATEGORY_HEAVY_EQUIPMENT = "HEAVY_EQUIPMENT";
export const CATEGORY_SURPLUS = "SURPLUS";
export const CATEGORY_OTHER = "OTHER";
